module.exports = __webpack_public_path__ + "img/saudi-professional-league-292__dark.84e3bf69.png";